<script setup>
import { computed } from 'vue';
import { DonutChart } from '@chatwoot/viz';

const props = defineProps({
  labels: Array,
  values: Array,
  colors: Array,
  title: String,
});

const total = computed(() =>
  props.values.reduce((sum, value) => sum + Number(value || 0), 0)
);

const chartData = computed(() => ({
  total: total.value,
  segments: props.labels.map((label, index) => ({
    id: `status-${index}`,
    label,
    value: Number(props.values[index] || 0),
    color: props.colors[index],
  })),
}));
</script>

<template>
  <div>
    <h3 class="font-semibold text-base mb-2">{{ title }}</h3>
    <DonutChart
      :data="chartData"
      :aria-label="title"
      :diameter="180"
      :thickness="24"
      class="w-full"
    />
  </div>
</template>
